module.exports = __webpack_public_path__ + "img/tk-active.4c0ffa1b.png";